import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import Logo from '../components/Logo';
import './SubscriptionCancel.css';

const SubscriptionCancel = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });

    return () => unsubscribe();
  }, []);

  const handleTryAgain = () => {
    navigate('/subscription-plans');
  };

  const handleGoToDashboard = () => {
    navigate('/profile');
  };

  const handleContactSupport = () => {
    const subject = encodeURIComponent('Suporte - Problema com Assinatura');
    const body = encodeURIComponent(
      'Olá equipe do Rastro+,\n\n' +
      'Tive problemas durante o processo de assinatura e gostaria de solicitar ajuda.\n\n' +
      '=== DESCRIÇÃO DO PROBLEMA ===\n' +
      '[Por favor, descreva aqui o que aconteceu. Algumas sugestões:]\n' +
      '• A página travou durante o pagamento\n' +
      '• Recebi uma mensagem de erro específica\n' +
      '• O cartão foi recusado mas deveria funcionar\n' +
      '• Quero mudar de plano antes de finalizar\n' +
      '• Tenho dúvidas sobre os recursos incluídos\n' +
      '• Outro motivo:\n\n' +
      '[Substitua este texto pela sua descrição]\n\n' +
      '=== INFORMAÇÕES DO USUÁRIO ===\n' +
      'Data/Hora: ' + new Date().toLocaleString('pt-BR', { 
        timeZone: 'America/Sao_Paulo',
        dateStyle: 'full',
        timeStyle: 'medium'
      }) + '\n' +
      'ID do Usuário: ' + (user?.uid || 'Não disponível') + '\n' +
      'Nome: ' + (user?.displayName || 'Não informado') + '\n' +
      'Email: ' + (user?.email || 'Não informado') + '\n\n' +
      'Aguardo retorno da equipe.\n\n' +
      'Atenciosamente,\n' +
      (user?.displayName || 'Usuário')
    );
    
    const mailtoUrl = `mailto:contato@rastromais.com?subject=${subject}&body=${body}`;
    window.location.href = mailtoUrl;
  };

  if (!user && !loading) {
    return (
      <div className="subscription-cancel">
        <div className="container">
          <div className="message-card">
            <div className="icon error">⚠️</div>
            <h1>Autenticação Necessária</h1>
            <p>Por favor, faça login para ver esta página.</p>
            <button onClick={() => navigate('/login')} className="action-btn">
              Ir para Login
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="subscription-cancel">
        <div className="container">
          <div className="loading">
            <div className="spinner"></div>
            <p>Carregando...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="subscription-cancel">
      <div className="container">
        <div className="message-card">
          <div className="icon cancel">❌</div>
          <h1>Assinatura Cancelada</h1>
          <p>O processo de assinatura foi cancelado. Nenhuma cobrança foi feita em sua conta.</p>

          <div className="reasons">
            <h3>Motivos comuns para cancelamento:</h3>
            <ul>
              <li>Mudou de ideia sobre a assinatura</li>
              <li>Quer revisar os detalhes do plano novamente</li>
              <li>Problemas com o método de pagamento</li>
              <li>Precisa entrar em contato com o suporte primeiro</li>
            </ul>
          </div>

          <div className="action-buttons">
            <button onClick={handleTryAgain} className="action-btn primary">
              Tentar Novamente
            </button>
            <button onClick={handleGoToDashboard} className="action-btn secondary">
              Ir para Dashboard
            </button>
            <button onClick={handleContactSupport} className="action-btn tertiary">
              Contatar Suporte
            </button>
          </div>

          <div className="help-section">
            <h4>Precisa de Ajuda?</h4>
            <p>
              Se você encontrou problemas durante o processo de assinatura ou tem dúvidas 
              sobre nossos planos, nossa equipe de suporte está aqui para ajudar.
            </p>
            <div className="contact-info">
              <p>📧 contato@rastromais.com</p>
              <p>📞 +55 🇧🇷 (11) 94261-8086</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionCancel;